import { defineSlotRecipe } from '@chakra-ui/react';
import colors from 'src/theme/colors';
import fonts from '../fonts';

const Select = defineSlotRecipe({
  slots: ['root', 'field', 'indicator'],
  base: {
    root: {
      background: 'white',
      borderRadius: '12px',
    },
    field: {
      color: 'podcastShade500',
      fontFamily: fonts.normal,
      borderRadius: '12px !important',
    },
  },
  variants: {
    visual: {
      primary: {
        field: {
          boxShadow: 'inset 0px -3px 6px rgba(205, 204, 227, 0.15)',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: 'podcastShade300',
          pl: '20px',
          _hover: {
            boxShadow: 'none',
          },
          _focus: {
            borderStyle: 'solid',
            borderWidth: '2px',
            borderColor: colors.podcastPurple,
            pl: '19px',
            _invalid: {
              borderStyle: 'solid',
              borderWidth: '3px',
              borderColor: 'AlituPink',
            },
          },
          _invalid: {
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: 'AlituPink',
            color: 'podcastRed600',
            boxShadow: 'inset 0px -3px 6px rgba(239, 57, 113, 0.05)',
          },
        },
      },
      fileType: {
        root: {
          border: 'none',
          borderRadius: '0px',
          my: '3px',
          width: '125px',
        },
        field: {
          pl: '10px',
          border: 'none',
          height: '100%',
          textTransform: 'uppercase',
          fontSize: '13px',
          fontFamily: fonts.bold,
          _focus: {
            outline: 'none',
          },
        },
      },
    },
    size: {
      small: {
        field: {
          height: '36px',
          fontSize: '13px',
          paddingInlineEnd: '8',
        },

        indicator: {
          insetEnd: '8px',
        },
      },
      large: {
        field: {
          height: '48px',
          fontSize: '16px',
          paddingInlineEnd: '8',
        },
        indicator: {
          insetEnd: '10px',
        },
      },
    },
  },
  defaultVariants: {
    visual: 'primary',
    size: 'large',
  },
});

export default Select;
